import { FC, useState } from "react";
import { TextField, Button, Box, Typography, Alert, CircularProgress } from "@mui/material";
import { sendContactFormEmail } from "@/actions/contactActions";

export const ContactForm: FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const result = await sendContactFormEmail(formData);
      
      if (result.success) {
        setSubmitted(true);
        // Reset the form after successful submission
        setFormData({
          name: "",
          email: "",
          message: "",
        });
      } else {
        setError(result.message || "Failed to send message. Please try again later.");
      }
    } catch (err) {
      setError("An unexpected error occurred. Please try again later.");
      console.error("Contact form submission error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        "& .MuiTextField-root": { m: 1, width: "600px" },
      }}
    >
      <Typography variant="h4" component="h1">
        Contact Us
      </Typography>
      <TextField
        label="Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        required
        disabled={loading}
      />
      <TextField
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        required
        disabled={loading}
      />
      <TextField
        label="Message"
        name="message"
        multiline
        rows={4}
        value={formData.message}
        onChange={handleChange}
        required
        disabled={loading}
      />
      <Button 
        type="submit" 
        variant="contained" 
        color="primary" 
        sx={{ mt: 2 }}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} /> : "Send"}
      </Button>
      {submitted && (
        <Alert severity="success" sx={{ mt: 2, width: "600px" }}>
          Message sent successfully!
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mt: 2, width: "600px" }}>
          {error}
        </Alert>
      )}
    </Box>
  );
};
